import React, { Component } from "react";
import { connect } from "react-redux";
import ContentIcon, { HEADING_GALLERY } from "ContentIcon";
import { screenHeightLeftFromTop } from "Constants";
import AddImages from "./add-images";
import GalleryList from "./gallery-item-list";
import InfoTutorial from "InfoTutorial";

class Gallery extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  callContentBoardStatus = () => {
    if (
      this.props.fetchGallery &&
      this.props.fetchGallery.meta &&
      this.props.fetchGallery.meta.count <= 1
    ) {
      this.props.contentBoardStatus();
    }
  };

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <ContentIcon heading={HEADING_GALLERY} />
          </div>

          <ul className="header-buttons">
            <li>
              <AddImages callContentBoardStatus={this.callContentBoardStatus} />
            </li>
            <li>
              <InfoTutorial video="gallery.mp4" />
            </li>
          </ul>
        </div>
        <div className="clearfix" />

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          <GalleryList callContentBoardStatus={this.callContentBoardStatus} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log("state.fetchGallery :- ", state.fetchGallery);

  return {
    session: state.session,
    deviceSize: state.deviceSize,
    fetchGallery: state.fetchGallery,
  };
}
export default connect(mapStateToProps)(Gallery);
